import { z } from 'zod';

// El backend serializa los montos KOin (BigInt) como strings mientras que los
// conteos (groupBy _count) viajan como number. Aceptamos ambos y normalizamos a
// number para que el dashboard no caiga a estado de error (CONTRACT_MISMATCH).
export const zRecordCounts = z.record(z.string(), z.coerce.number());
export const zIsoString = z.string();

export function cursorPage<S extends z.ZodTypeAny>(item: S) {
  return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}
export type CursorPage<T> = { items: T[]; nextCursor: string | null };

/**
 * A write receipt that may arrive as an EMPTY body.
 *
 * Until ko-backend's final audit fix (2026-09-23, P2-2/P2-3), a handler that
 * returned `null` went out as a 200 with nothing in it — Nest sends no body
 * for a nil value — and axios hands that over as `""`. A deployed backend can
 * still answer that way, so `""` is read as the `null` it meant instead of as
 * contract drift.
 */
export function emptyBodyAsNull<S extends z.ZodTypeAny>(schema: S) {
  return z.preprocess((v) => (v === '' ? null : v), schema);
}
